<style scoped lang="scss">
.uk-card {
  color: black;
  background-color: #ddd !important;
  padding: 40px;
  padding-bottom: 35px;
  font-size: 1.2em;
  border-radius: 6px;
}
</style>

<template>
  <vk-modal :show.sync="show" class="uk-width-1-1 uk-margin-large-top uk-margin-large-bottom uk-form">
    <vk-modal-close></vk-modal-close>
    <div class="uk-grid" v-if="loading">
      <div class="uk-width-1-1">
        <h2>Loading...</h2>
      </div>
    </div>
    <div class="uk-grid" v-else>

      <div class="uk-width-1-1">
        <ul uk-tab>
          <li :class="{'uk-active': tab === 'removed'}"><a @click="tab = 'removed'" href="javascript:;">Previously Removed ({{ unitLedgerEntries.length }})</a></li>
          <li :class="{'uk-active': tab === 'history'}"><a @click="tab = 'history'" href="javascript:;">Ledger Entry History ({{currentEntryHistory.length}})</a></li>
        </ul>
      </div>

      <div v-if="tab === 'removed'" class="uk-width-1-1 uk-margin-large-top">
        <h2>Restore Previously Removed Entries for {{ type.name }}</h2>
      </div>
      <div v-if="tab === 'removed'" class="uk-width-1-1 uk-margin-top">
        <h4>
          <validated-section :errors="errors" :field="'unit_ledger_entries.duplicate'">
            &nbsp;
          </validated-section>
        </h4>
        <div v-if="unitLedgerEntries.length === 0">
          <div class="uk-card uk-card-default uk-text-center">
            <h2 class="uk-align-center">No Entries to Restore</h2>
          </div>
        </div>
        <table v-else class="uk-table uk-table-striped">
          <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Month</th>
            <th class="uk-text-right">{{ programSettings['ledger-title-amount-due'] }}</th>
            <th class="uk-text-right">{{ programSettings['ledger-title-amount-paid'] }}</th>
            <th class="uk-text-right" v-if="programSettings['uses-ledger-entry-fees']">
              {{ programSettings['ledger-title-amount-fees-due'] }}
            </th>
            <th class="uk-text-right">Approved</th>
            <th class="uk-text-right">Vendor</th>
            <th class="uk-text-right">Account #</th>
            <th class="uk-text-right">Last Updated By</th>
            <th class="uk-text-right">Last Updated</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="ule in unitLedgerEntries">
            <td>
              <input type="checkbox"
                     @change="onChecked(ule)"
                     :disabled="!canCheckEntry(ule.id) && !selectedIds.includes(ule.id)"
                     v-model="selectedIds" :value="ule.id" class="uk-checkbox">
            </td>
            <td>{{ ule.id }} {{ ule.due_date | moment('MMM YYYY') }}</td>
            <td class="uk-text-right">{{ ule.amount_due | formatMoney }}</td>
            <td class="uk-text-right">
                <span v-if="ule.amount_paid">
                  {{ ule.amount_paid | formatMoney }}
                </span>
              <span v-else>$0.00</span>
            </td>
            <td class="uk-text-right" v-if="programSettings['uses-ledger-entry-fees']">{{ ule.fees_due }}</td>
            <td class="uk-text-right">
                <span v-if="ule.pivot.assistance_amount_approved">
                  {{ ule.pivot.assistance_amount_approved | formatMoney }}
                </span>
              <span v-else>-</span>
            </td>
            <td class="uk-text-right">
                <span v-if="ule.organization">
                  {{ ule.organization.organization_name }}
                </span>
            </td>

            <td class="uk-text-right">
                <span v-if="ule.account_number">
                  {{ ule.account_number }}
                </span>
            </td>
            <td class="uk-text-right">
                <span v-if="ule.causer">
                  {{ ule.causer.name }}
                </span>
              <span v-else>-</span>
            </td>
            <td class="uk-text-right">
              {{ ule.deleted_at | moment }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>



      <div v-if="tab === 'history'" class="uk-width-1-1 uk-margin-large-top">
        <h2>Restore From {{ type.name }} History</h2>
      </div>
      <div class="uk-width-1-1 uk-margin-top" v-if="tab === 'history'">
        <div v-if="currentEntryHistory.length === 0" class="uk-card uk-card-default uk-text-center">
          <h2 class="uk-align-center">No Entries to Restore</h2>
        </div>
        <table v-else class="uk-table uk-table-striped">
          <thead>
          <tr>
            <th>&nbsp;</th>
            <th>ID</th>
            <th>Month</th>
            <th class="uk-text-right">{{ programSettings['ledger-title-amount-due'] }}</th>
            <th class="uk-text-right">{{ programSettings['ledger-title-amount-paid'] }}</th>
            <th class="uk-text-right" v-if="programSettings['uses-ledger-entry-fees']">
              {{ programSettings['ledger-title-amount-fees-due'] }}
            </th>
            <th class="uk-text-right">Vendor</th>
            <th class="uk-text-right">Account #</th>
            <th class="uk-text-right">Last Updated By</th>
            <th class="uk-text-right">Last Updated</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="history in currentEntryHistory">
            <td>
              <input type="checkbox"
                     @change="onChecked(history)"
                     v-model="selectedIds" :value="history.id" class="uk-checkbox">
            </td>
            <td>{{ history.subject.id }}</td>
            <td>{{ history.subject.due_date | moment('MMM YYYY') }}</td>

            <td class="uk-text-right">
              <span v-if="history.properties.old && history.properties.old.amount_due">
                {{ history.properties.old.amount_due | formatMoney }}
              </span>
              <span v-else>
                {{ history.subject.amount_due | formatMoney }}
              </span>
            </td>

            <td class="uk-text-right">
              <span v-if="history.properties.old && history.properties.old.amount_paid">
                {{ history.properties.old.amount_paid | formatMoney }}
              </span>
              <span v-else>
                <span v-if="history.subject.amount_paid">
                  {{ history.subject.amount_paid | formatMoney }}
                </span>
                <span v-else>$0.00</span>
              </span>

            </td>
            <td class="uk-text-right" v-if="programSettings['uses-ledger-entry-fees']">
              <span v-if="history.properties.old && history.properties.old.fees_due">
                {{ history.properties.old.fees_due | formatMoney }}
              </span>
              <span v-else>
                {{ history.subject.fees_due | formatMoney }}
              </span>
            </td>

            <td class="uk-text-right">
                <span v-if="history.subject.organization">
                  {{ history.subject.organization.organization_name }}
                </span>
            </td>

            <td class="uk-text-right">
                <span v-if="history.subject.account_number">
                  {{ history.subject.account_number }}
                </span>
            </td>
            <td class="uk-text-right">
                <span v-if="history.causer">
                  {{ history.causer.name }}
                </span>
              <span v-else>-</span>
            </td>
            <td>
              {{ history.created_at | moment('MM/DD/YYYY')}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-if="vendorListLength > 1">
        <h3>Please Select a Vendor:</h3>
        <div v-for="vendor in selectedVendors">
          <label
              :for="'vendor_'+vendor.id">
            <input type="radio" v-model="selectedVendorId" :value="vendor.id">
            {{ vendor.organization_name }}
          </label>
        </div>
      </div>

      <div class="uk-width-1-1 uk-margin-large-top uk-text-center">
        <button class="uk-button uk-button-default" @click="close">Close</button>
        <button class="uk-button uk-button-success" @click="save" :disabled="selectedIds.length === 0 || saving">
          <span v-if="saving">Restoring...</span>
          <span v-else>Restore Selected Entries</span>
        </button>
      </div>
    </div>
  </vk-modal>
</template>

<script>
import {mapState} from "vuex";
import ValidatedSection from "./ValidatedSection";
export default {
  name: "UnitLedgerEntryHistoryModal",
  components: {
    ValidatedSection
  },
  props: ['type'],
  data() {
    return {
      errors: {},
      loading: false,
      saving: false,
      show: false,
      unitLedgerEntries: [],
      currentEntryHistory: [],
      selectedIds: [],
      selectedVendorId: null,
      tab: 'removed',
    }
  },
  computed: {
    vendorListLength() {
      return _.size(this.selectedVendors);
    },
    selectedVendors() {
      let vendors = {};
      _.each(this.selectedIds, id => {
        if(this.tab === 'removed') {
          let entry = this.entryForId(id);
          if(vendors[entry.vendor_organization_id] === undefined) {
            vendors[entry.vendor_organization_id] = entry.organization;
          }
        }

        if(this.tab === 'history') {
          let entry = this.historyForId(id);
          if(vendors[entry.subject.vendor_organization_id] === undefined) {
            vendors[entry.subject.vendor_organization_id] = entry.subject.organization;
          }
        }

      })
      return vendors;
    },
    ...mapState('Application', {
      application: state => state.application,
      programSettings: state => state.application.program.settings,
    })
  },
  watch: {
    tab(newValue) {
      this.selectedIds = [];
      this.selectedVendorId = null;
    }
  },
  mounted() {
    this.errors = {}
  },
  methods: {
    canCheckEntry(id) {
      // If another month exists for the entry date, return false
      let entry = this.entryForId(id);
      let entryDateString = moment(entry.due_date).format('YYYYMM');
      for(var i in this.selectedIds) {
        let selectionEntry = this.entryForId(this.selectedIds[i]);
        let selectionEntryDateString = moment(selectionEntry.due_date).format('YYYYMM');
        if(entryDateString === selectionEntryDateString) return false;
      }
      return true;

    },
    entryForId(id) {
      for(var i in this.unitLedgerEntries) {
        let e = this.unitLedgerEntries[i];
        if(e.id === id) {
          return e;
        }
      }
      return null;
    },
    historyForId(id) {
      for(var i in this.currentEntryHistory) {
        let e = this.currentEntryHistory[i];
        if(e.id === id) {
          return e;
        }
      }
      return null;
    },
    async open() {
      this.show = true;
      await this.getData();
    },
    async getData() {
      this.loading = true;
      let r = await axios.get('/api/hope/applications/'+this.application.id+'/ule-history?unit_ledger_entry_type_id='+this.type.id);
      this.unitLedgerEntries = r.data.ules;
      this.currentEntryHistory = r.data.history;
      this.loading = false;
    },
    onChecked(entry) {
      if(!this.selectedVendorId) {
        if(this.tab === 'removed') {
          this.selectedVendorId = entry.vendor_organization_id;
        }else {
          this.selectedVendorId = entry.subject.vendor_organization_id;
        }
      }
    },

    onHistoryChecked(history) {

    },
    close() {
      this.unitLedgerEntries = [];
      this.selectedIds = [];
      this.selectedVendorId = null;
      this.show = false;
    },
    async save() {
      if(!this.selectedVendorId && this.type.id !== 1 && this.vendorListLength > 0) {
        UIkit.modal.alert('You must select a vendor.');
        return;
      }
      this.saving = true;
      this.errors = {};
      try {
        let r = await axios.post('/api/hope/applications/'+this.application.id+'/ule-history', {
          unit_ledger_entry_type_id: this.type.id,
          vendor_id: this.selectedVendorId,
          tab: this.tab,
          ids: this.selectedIds
        })
        await this.$store.dispatch('Application/fetch', this.application.id);
        this.$emit('onRestoreUle', {vendor: r.data.vendor, ules: r.data.ules});
        this.close();
      }catch(e) {
        this.errors = e.response.data.errors;
      }
      this.saving = false;
    }
  }
}
</script>
